// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Sentry from "./sentry/Sentry.bs.js";
import * as Logger$Catalyst from "../../node_modules/@porterin/catalyst/src/helper-modules/logger/Logger.bs.js";
import * as ErrorUtils$Catalyst from "../../node_modules/@porterin/catalyst/src/utils/ErrorUtils.bs.js";

function catchPromiseError(promise, requestUrl) {
  return promise.catch(function (error) {
              Logger$Catalyst.error("------promise caught error------");
              Logger$Catalyst.error(error);
              Sentry.captureException({
                    api_request: {
                      url: requestUrl
                    }
                  }, {
                    error_kind: "API_ERROR_CONTRACT",
                    type: "API_ERROR_CONTRACT",
                    caught_by: "NetworkUtils"
                  }, error);
              return Promise.resolve({
                          TAG: /* Error */1,
                          _0: ErrorUtils$Catalyst.getDefaultErrorEntity(JSON.stringify(error), undefined, undefined)
                        });
            });
}

export {
  catchPromiseError ,
  
}
/* Sentry Not a pure module */
